import { useRef, useState } from "react";
import { useApi } from "../../context/ApiProvider";

export default function PushNotifications(props) {

  const pushNotification_sv = useRef();
  const pushNotification_en = useRef();
  const [isSendingPush, setIsSendingPush] = useState(false);
  const [sendPushNotificationSuccess, setSendPushNotificationSuccess] = useState(false);
  const [sendPushNotificationError, setSendPushNotificationError] = useState(false);
  const Api = useApi();

  const sendPushNotification = () => {

    const message_sv = pushNotification_sv.current.value;
    const message_en = pushNotification_en.current.value;

    if (message_sv === "" && message_en === "") {
      alert("Swedish and/or English messages must be filled in");
      return;
    }

    const payload = {
      message_sv,
      message_en
    }

    setIsSendingPush(true);
    Api.post('/rolf/pushnotifications', payload).then(response => {
      pushNotification_en.current.value = "";
      pushNotification_sv.current.value = "";
      setSendPushNotificationSuccess(true);
    }).catch(e => {
      setSendPushNotificationError(e.error);
    }).finally(() => {
      setIsSendingPush(false);
      setTimeout(() => {
        setSendPushNotificationSuccess(false);
        setSendPushNotificationError(false);
      }, 3000)
    
    });
    

    console.log(payload);
  }

  return (
    <div className="grid-container">
      <section>
        <h4>Push notifications</h4>
        <p>Send mass push notifications to all registered devices</p>
        {sendPushNotificationSuccess && <div className="formControlSuccess">Push notification sent</div>}
        {sendPushNotificationError && <div className="formControlError">{sendPushNotificationError}</div>}

        <label>Swedish message</label>
        <textarea ref={pushNotification_sv} rows="4" cols="50" placeholder="Type your message here" className="formControl"></textarea>

        <label>English message</label>
        <textarea ref={pushNotification_en} rows="4" cols="50" placeholder="Type your message here" className="formControl"></textarea>

        <button id="sendPushNotification" onClick={sendPushNotification} disabled={isSendingPush}>Send push notification</button>
      </section>
    </div>
  )
}